/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  questionsAnalysisData: null,
  dropDowns: null,
  wordGraphData: [],
  respondents: '0/0',
  filters: {},
  report: [],
  reportdata: [],
  cohort: [],
  stitchResponse: {},
  projectDuration: null,
  projectName: null,
  clipsData: {
    questionsAnalysisData: {} // Data will be stored as { [questionId]: data }
  },
  clipsDataWithoutUrl: [],
  questionsAnalysisData1: null,
  questionsAnalysisData2: null,
  deleteCustomtagStatus: null,
  editCustomTagStatus: null,
  deleteCohortStatus: null,
  isLoadingVideo: false,
  questionsAnalysisDataStatus: null,
  questionsScreenerAnalysisDataStatus: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.analysisAction.REQUEST_ANALYSIS_DATA:
      return {
        ...state,
        questionsAnalysisDataStatus: null
      };

    case actions.analysisAction.REQUEST_SCREENER_ANALYSIS_DATA:
      return {
        ...state,
        questionsScreenerAnalysisDataStatus: null
      };

    case actions.analysisAction.ANALYSIS_DATA_RECEIVED:
      return {
        ...state,
        questionsAnalysisData: action?.data?.questionsAnalysisData,
        dropDowns: action?.data?.dropDowns,
        respondents: action?.data?.Respondents,
        projectDuration: action?.data?.projectDuration,
        questionsAnalysisDataStatus: action?.data?.Status ?? null,
        projectName: action?.data?.projectName

      };
    case actions.analysisAction.ANALYSIS_SCREENER_DATA_RECEIVED:
      return {
        ...state,
        questionsScreenerAnalysisData: action?.data?.questionsAnalysisData,
        dropDownsScreener: action?.data?.dropDowns,
        respondentsScreener: action?.data?.Respondents,
        projectDurationScreener: action?.data?.projectDuration,
        questionsScreenerAnalysisDataStatus: action?.data?.Status ?? null
      };
    case actions.analysisAction.REQUEST_ANALYSIS_CSV:
      let t1 = state;
      return { ...t1 };

    case actions.analysisAction.REQUEST_ANALYSIS_CSV_WITH_CODE:
      let t2 = state;
      return { ...t2 };

    case actions.analysisAction.ANALYSIS_CSV_RECEIVED:
      return {
        ...state,
        // action,
        questionsAnalysisData1: action?.data?.questionsAnalysisData
        // dropDowns: action?.data?.dropDowns,
        // respondents: action?.data?.Respondents,
        // projectDuration : action?.data?.projectDuration,
        // userid: action.payload.user_ID,
        // projectid: action.payload.project_ID,
      };

    case actions.analysisAction.ANALYSIS_CSV_RECEIVED_WITH_CODE:
      return {
        ...state,
        questionsAnalysisData2: action?.data?.questionsAnalysisData
      };
    case actions.analysisAction.REQUEST_WORD_ANSWER:
      return {
        ...state
      };
    case actions.analysisAction.WORD_ANSWER_RECEIVED:
      return {
        ...state,
        wordGraphData: action.data.WordCloudAnswers
        // userid: action.payload.user_ID,
        // projectid: action.payload.project_ID,
      };
    case actions.analysisAction.REQUEST_FILTER_DATA:
      return {
        ...state
      };
    case actions.analysisAction.FILTER_DATA_RECEIVED:
      return {
        ...state,
        filters: action?.data
        // userid: action.payload.user_ID,
        // projectid: action.payload.project_ID,
      };
    case actions.analysisAction.ADD_TO_REPORT:
      return {
        ...state,
        report: action.data
      };
    case actions.analysisAction.UPDATE_REPORT:
      return {
        ...state,
        reportdata: action.data
      };
    case actions.analysisAction.REQUEST_ADD_COHORT:
      return {
        ...state
      };
    case actions.analysisAction.ADD_COHORT_RESPONSE:
      return {
        ...state,
        cohort: action?.data?.cohortData
      };

    case actions.analysisAction.REQUEST_STICH_VIDEO:
      return {
        ...state
      };
    case actions.analysisAction.STICH_VIDEO_RESPONSE:
      return {
        ...state,
        stitchResponse: action?.data
      };

    case actions.analysisAction.REQUEST_ANALYSIS_CLIPS_DATA:
      return {
        ...state,
        isLoadingVideo: {
          ...state.isLoadingVideo,
          [action.question_ID]: true
        }
      };
    case actions.analysisAction.REQUEST_ANALYSIS_CLIPS_WITHOUT_URL:
      return {
        ...state
      };
    case actions.analysisAction.ANALYSIS_CLIPS_DATA_RECEIVED:
      const { question_ID, data } = action;
      return {
        ...state,
        clipsData: {
          ...state.clipsData,
          questionsAnalysisData: {
            ...state.clipsData?.questionsAnalysisData,
            [question_ID]: data
          }
        },
        isLoadingVideo: {
          ...state.isLoadingVideo,
          [question_ID]: false
        }
      };
    case actions.analysisAction.ANALYSIS_CLIPS_WITHOUT_URL_RECEIVED:
      return {
        ...state,
        clipsDataWithoutUrl: action?.data
      };
    case actions.analysisAction.DELETE_CUSTOMTAG_RECEIVED:
      return {
        ...state,
        deleteCustomtagStatus: action?.data.Status
      };
    case actions.analysisAction.CLEAR_DELETE_CUSTOMTAG:
      return {
        ...state,
        deleteCustomtagStatus: null
      };
    case actions.analysisAction.CUSTOM_TAG_UPDATE_RECEIVED:
      return {
        ...state,
        editCustomTagStatus: action?.data.Status
      };
    case actions.analysisAction.CLEAR_CUSTOM_TAG_UPDATE:
      return {
        ...state,
        editCustomTagStatus: null
      };
    case actions.analysisAction.DELETE_COHORT_RECEIVED:
      return {
        ...state,
        deleteCohortStatus: action?.data.Status
      };
    case actions.analysisAction.CLEAR_DELETE_COHORT:
      return {
        ...state,
        deleteCohortStatus: null
      };
    default:
      return state;
  }
};

export default reducer;
